module.exports = __webpack_public_path__ + "static/GT-Haptik-Medium-d56205e9704a3ae6901962fe80a2e1ee.woff";